import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = false
}: CardProps) {
  return <motion.div className={`bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden ${className}`} whileHover={hoverEffect ? {
    y: -5,
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  } : undefined} transition={{
    duration: 0.2
  }} data-id="element-25">
      {children}
    </motion.div>;
}